"use strict";

exports.__esModule = true;
exports.datasetEvents = exports.DatasetEvents = void 0;
var _errors = require("../common/errors");
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _events = /*#__PURE__*/new WeakMap();
class DatasetEvents {
  constructor() {
    _classPrivateFieldInitSpec(this, _events, new Map());
  }
  static of() {
    return new DatasetEvents();
  }
  on(dataset, event, listener) {
    if (!_classPrivateFieldGet(_events, this).has(dataset.id)) {
      _classPrivateFieldGet(_events, this).set(dataset.id, new Map());
    }
    const events = _classPrivateFieldGet(_events, this).get(dataset.id);
    if (!events.has(event)) {
      events.set(event, new Set());
    }
    const listeners = events.get(event);
    listeners.add(listener);
  }
  off(dataset, event, listenerToUnsubscribe) {
    if (_classPrivateFieldGet(_events, this).has(dataset.id)) {
      const events = _classPrivateFieldGet(_events, this).get(dataset.id);
      if (events.has(event)) {
        const listeners = events.get(event);
        const removed = listeners.delete(listenerToUnsubscribe);
        if (!removed) {
          throw _errors.AppError.of(`Can't unsubscribe a listener that was not subscribed`);
        }
        if (listeners.size === 0) {
          events.delete(event);
          if (events.size === 0) {
            _classPrivateFieldGet(_events, this).delete(dataset.id);
          }
        }
      } else {
        throw _errors.AppError.of(`Can't unsubscribe from non existent event`);
      }
    } else {
      throw _errors.AppError.of(`Dataset "${dataset.id}" has no subscriptions`);
    }
  }
  emit(dataset, event, ...args) {
    if (_classPrivateFieldGet(_events, this).has(dataset.id)) {
      const events = _classPrivateFieldGet(_events, this).get(dataset.id);
      if (events.has(event)) {
        for (const listener of events.get(event)) {
          listener(...args);
        }
      }
    }
  }
}
exports.DatasetEvents = DatasetEvents;
const datasetEvents = exports.datasetEvents = DatasetEvents.of();
//# sourceMappingURL=dataset-events.js.map